// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../shared/images/WriterLogo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navmenu-container {
    margin: 0;
    background-color: rgb(102,102,102);
    height: 100%;
    min-height: 100vh;
}

.logo {
    color: white;
}

.logo__image {
    height: 4rem;
    display: block;
    margin-left: 0.5rem;
}

.logo__title {    
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;    
    margin: 16px 0px 3px 0px;
    height: 18px;
}

.nav-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.navmenu__link-img {
    width: 2.4em;
    height: 2.4em;
    margin: auto;
}

.navmenu__link {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
    color: white;
    width: 3em;
    font-size: 1.4rem;
}

.navmenu__link:hover .navmenu__link-img {
    transition: 0.3s;
    transform: translateY(-8px);
}
`, "",{"version":3,"sources":["webpack://./src/app/nav-menu/NavMenu.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,kCAAkC;IAClC,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gDAA+C;IAC/C,4BAA4B;IAC5B,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B","sourcesContent":[".navmenu-container {\r\n    margin: 0;\r\n    background-color: rgb(102,102,102);\r\n    height: 100%;\r\n    min-height: 100vh;\r\n}\r\n\r\n.logo {\r\n    color: white;\r\n}\r\n\r\n.logo__image {\r\n    height: 4rem;\r\n    display: block;\r\n    margin-left: 0.5rem;\r\n}\r\n\r\n.logo__title {    \r\n    content: url('../shared/images/WriterLogo.svg');\r\n    background-repeat: no-repeat;    \r\n    margin: 16px 0px 3px 0px;\r\n    height: 18px;\r\n}\r\n\r\n.nav-item {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.navmenu__link-img {\r\n    width: 2.4em;\r\n    height: 2.4em;\r\n    margin: auto;\r\n}\r\n\r\n.navmenu__link {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    margin-top: 1rem;\r\n    color: white;\r\n    width: 3em;\r\n    font-size: 1.4rem;\r\n}\r\n\r\n.navmenu__link:hover .navmenu__link-img {\r\n    transition: 0.3s;\r\n    transform: translateY(-8px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
